
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

const MOBILE_BREAKPOINT = 768

export default Vue.extend({
  name: 'Carousel',
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  props: {
    arrows: {
      type: Boolean,
      required: false,
      default: false
    },
    pagination: {
      type: Boolean,
      required: false,
      default: false
    },
    mainSlider: {
      type: Boolean,
      required: false,
      default: false
    }

  },
  data () {
    return {
      currentBanner: null,
      bannerBlock: {},
      defaultSplideOptions: {
        type: 'loop',
        pagination: false,
        autoplay: 5000,
        pauseOnFocus: false,
        breakpoints: {
          1023: {
            pagination: true
          }
        }
      },
      breakpoints: [
        {
          pictureType: 'image400',
          imageWidth: 400,
          maxWidth: 400
        },
        {
          pictureType: 'image700',
          imageWidth: 700,
          maxWidth: 700
        },
        {
          pictureType: 'image1000',
          imageWidth: 1000,
          maxWidth: 767
        },
        {
          pictureType: 'image1000',
          imageWidth: 1000,
          maxWidth: 1000
        },
        {
          pictureType: 'image1800',
          imageWidth: 1800,
          maxWidth: 1800
        },
        {
          pictureType: 'image2800',
          imageWidth: 2800,
          maxWidth: 3000
        }
      ],
      activeSlideIndex: 0,

      thumbsOptions: {
        rewind: true,
        pagination: false,
        arrows: false,
        perPage: 4,
        gap: 20,
        isNavigation: true,
        updateOnMove: true
      },

      isMounted: false
    }
  },
  async fetch () {
    try {
      this.bannerBlock = await this.$banners.getBannerBlockByCode(this.mainFields?.code?.value)
    } catch (e: any) {
      console.error(e)
    }

    if (+this.$route?.query?.form === this.getFormId(this.currentBanner)) {
      this.setFormSettings()
    }
  },
  watch: {
    bannerBlock (bannerBlock) {
      if (!bannerBlock?.banners?.length) { return }
      setTimeout(() => {
        this.$refs.splide?.sync(this.$refs.thumbs.splide)
      })
    }
  },

  mounted () {
    this.isMounted = true
    setTimeout(() => {
      this.$refs.splide?.sync(this.$refs.thumbs.splide)
    })
  },

  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.currentBanner,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong
      })
    },
    openModal (banner: any) {
      let temp
      if (this.banner.url) {
        temp = this.getFormId(banner)
        this.currentBanner = temp
      }
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: temp } })
    },
    changeSlide (idx: number) {
      this.$refs.splide.go(idx)
    },
    onSlideChange (_, idx: number) {
      this.activeSlideIndex = idx
    },
    imageBreakpoints (banner) {
      return this.breakpoints.map(breakpoint => ({
        ...breakpoint,
        fileId: breakpoint.maxWidth < MOBILE_BREAKPOINT ? banner.mobileFile?.fileId || banner.image.fileId : banner.image.fileId
      }))
    },
    mergeSplideOptionsWithDefault () {
      return Object.assign({},
        this.defaultSplideOptions,
        {
          pagination: this.pagination,
          arrows: this.arrows,
          mainSLider: this.mainSlider
        }
      )
    },
    getFormId (banner: any) {
      return banner?.params?.find((el: { name: string }) => el.name === 'formId')?.value
    }
  }
})
